// Pure derivation helpers for Intercom attribute mapping.
// MIRRORS backend: apps/llm-monitor-node/backend/src/domain/intercom/helpers/intercomDerivations.ts
// Both files must be kept in sync if the derivation logic changes.

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const calculateTrialDaysRemaining = (
  accountStatus: string,
  created: Date | string,
  trialDays: number,
  now: Date = new Date()
): number | null => {
  if (accountStatus !== 'TRIAL') return null;
  const elapsedDays = Math.floor((now.getTime() - new Date(created).getTime()) / MS_PER_DAY);
  return Math.max(0, trialDays - elapsedDays);
};

export const normalizeBillingCycle = (billingInterval: string | null): string | null => {
  if (billingInterval === 'month') return 'monthly';
  if (billingInterval === 'year') return 'annual';
  return null;
};

export const toUnixSeconds = (date: Date | string | null | undefined): number | null => {
  if (!date) return null;
  return Math.floor(new Date(date).getTime() / 1000);
};
